// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__14Lnz","head":"ProcedureTableInfo_head__3ShJF"};